import React, {useState} from "react";
import { useTranslation, Trans } from "react-i18next";
import { Menu, Divider, Image, Icon, Modal, Button } from "semantic-ui-react";
import { generateRoutePath } from "../../router/routes-helpers";
import Avatar from "../tags/Avatar";
import { PartnerTag } from "/imports/client/components/tags";
import useRoute from "/imports/client/router/useRoute";

function GetMobileAppModal({show, showModal}) {

  return (
    <Modal
      onClose={() => showModal(false)}
      onOpen={() => showModal(true)}
      open={show}
    >
      <Modal.Header><Trans i18nKey="mobile.modal.title" /></Modal.Header>
      <Modal.Content image>
        <Image size='medium' src='https://assets.transmate.eu/app/iphone-mockup.png' wrapped />
        <Modal.Description>
          <p>
          <Trans i18nKey="mobile.modal.body" />
          </p>
          <div>
          <Image size='small' src='https://assets.transmate.eu/app/QR_Code_getMobileApp.png' centered />
          </div>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={() => showModal(false)}>
          <Trans i18nKey={"form.cancel"} />
        </Button>
        <Button
          content="Yes, I got it!"
          labelPosition='right'
          icon='checkmark'
          onClick={() => showModal(false)}
          positive
        />
      </Modal.Actions>
    </Modal>
  )
}


const UserMenu = ({ ...props }) => {
  const [show, showModal] = useState(false);
  const { replaceHrefClick } = useRoute();
  const { t } = useTranslation();
  const { currentUser = {}, account = {} } = props;

  return (
    <div className="ui simple dropdown item" data-test="userMenu">
      <div style={{ marginRight: "2px" }}>
        <Avatar userId={currentUser?.id} />
      </div>
      {currentUser.name}
      <Icon name="dropdown" />
      <Menu>
        <Menu.Item
          as="a"
          onClick={(e) => replaceHrefClick(e, "settings", { section: "user-profile" })}
          href={generateRoutePath("settings", { section: "user-profile" })}
          content={<>
            <Icon name="cog" />
            {t("settings.title")}
            </>
            }
        />
        <Menu.Item
          as="a"
          onClick={(e) => replaceHrefClick(e, "settings", { section: "account-profile" })}
          href={generateRoutePath("settings", { section: "account-profile" })}
          content={
            <>
              <Icon name="factory" />
              {t("account.portal.title")} <span style={{ opacity: 0.4 }}>{account.name}</span>
            </>
          }
        />
        <Menu.Item
          as="a"
          onClick={()=> showModal(true)}
          content={
            <>
              <Icon name="mobile alternate" />
              {t("mobile.get")}
            </>
          }
        />
        <Menu.Item
          as="a"
          className="logout"
          href="/logout"
          content={<>
          <Icon name="log out" />
          {t("account.tabs.logout")}
          </>}
          data-test="logout"
        />
        <div className="header">
          <Divider />
          {currentUser.name}
          <br />
          {account && <PartnerTag {...{ accountId: account.id, name: account.name }} />}
        </div>
      </Menu>
      <GetMobileAppModal show={show} showModal={showModal} />
    </div>
  );
};

export default UserMenu;
